import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { Header } from '../components'
import { SwitchWithRoutes } from '../app/routes'
import { signOut } from '../../common/auth/actions'

import './Authorized.scss'

const AuthorizedPage = ({ routes, viewer, signOut, version }) => {
  if (!viewer) return <Redirect to="/sign-in" />
  return (
    <div className="page">
      <Header viewer={viewer} signOut={signOut} version={version} />
      <SwitchWithRoutes routes={Object.values(routes)} />
    </div>
  )
}

AuthorizedPage.defaultProps = {
  viewer: null,
  children: null,
  version: '',
}

AuthorizedPage.propTypes = {
  routes: React.PropTypes.object.isRequired,
  viewer: React.PropTypes.object,
  signOut: React.PropTypes.func.isRequired,
  version: React.PropTypes.string,
}

export default connect(state => ({
  viewer: state.users.viewer,
  version: state.config.appVersion,
}), { signOut })(AuthorizedPage)



// WEBPACK FOOTER //
// ./src/browser/pages/Authorized.js